<div class="default-page container-fluid center">
  <div fxLayout="column" fxLayoutAlign="center center">
    <div class="mat-h2 title">Unknown Address</div>
    <div class="width-100 separator-bottom" fxFlex="1 1 auto" fxLayout="column" fxLayoutAlign="center center">
      <div class="mat-body bottom-text icon-hover"><a href="#" [routerLink]="navigationForPortalRoot()">Back to Portal<span class="mdi mdi-arrow-right"></span></a></div>
    </div>
  </div>
</div>
